import { Component, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { BehaviorSubject, map, Observable, of, Subject, takeUntil, tap } from 'rxjs';
import {
  AVAILABLE_LANGUAGES,
  DEFAULT_ROLES_TO_HIDE_SET,
  PERMITTED_VIEWS,
  USER_TYPE,
} from 'src/app/core/helpers/global/global.constant';
import {
  AGENT_BALANCE_MOMENTS,
  AGENT_BALANCE_SOURCES,
  AGENT_BALANCE_UNCHANGED_REASONS,
  INIT_FILTERS_REPORTS,
  MONEY_TYPE,
  MONEY_TYPE_BADGE_OPTIONS,
  PAYMENT_TYPE,
  PAYMENT_TYPE_BADGE_OPTIONS,
  TRANSACTION_COLUMN_NAMES,
  TRANSACTION_ORIGIN_COLUMN_WIDTH,
  TRANSACTION_TYPE,
  TRANSACTION_TYPE_BADGE_OPTIONS,
  TRASACTION_STATUS,
  TRASACTION_STATUS_BADGE_OPTIONS,
} from 'src/app/core/helpers/global/reports.constant';
import { formatNumberTwoDecimals } from 'src/app/core/helpers/global/two-decimals-global-tables.utils';
import {
  TRANSACTION_ORIGIN_DEFAULT_FLAG_CLASS,
  TRANSACTION_ORIGIN_FLAG_CLASSES,
  TRANSACTION_ORIGINS,
} from 'src/app/core/helpers/global/financial.constant';
import { DEFAULT_NGX_DATATABLE_PAGINATION } from 'src/app/core/helpers/ui/ngx-datatable.constant';
import {
  BUTTON_ACTIONS,
  FORMAT_FOR_DATES_LONG,
  FORMAT_FOR_NUMBER_DIGITS,
} from 'src/app/core/helpers/ui/ui.constant';
import { DownloadReportRequest } from 'src/app/core/interfaces/api/report.interface';
import { getRefId, orderColumnsByName } from 'src/app/core/helpers/global/global.util';
import { TransactionAdmin } from 'src/app/core/interfaces/api/transaction.interface';
import { User } from 'src/app/core/interfaces/api/user.interface';
import { ModalWithAction } from 'src/app/core/interfaces/ui/bootstrap-modal.interface';
import { AgentBalanceMoment, AgentBalanceSource } from 'src/app/core/interfaces/ui/ui.interface';
import {
  NgxDatatableColumn,
  NgxDatatableConfig,
} from 'src/app/core/interfaces/ui/ngx-datatable.interface';
import { TransferService } from 'src/app/core/services/api/transfer-user.service';
import { BootstrapModalService } from 'src/app/core/services/ui/bootstrap-modal.service';
import { FilterService } from 'src/app/core/services/ui/filter.service';
import { GlobalService } from 'src/app/core/services/ui/global.service';
import { LanguageService } from 'src/app/core/services/ui/language.service';
import { ReportDownloadService } from 'src/app/core/services/ui/report-download.service';

@Component({
  selector: 'app-transactions-reports-table',
  templateUrl: './transactions-reports-table.component.html',
})
export class TransactionsReportsTableComponent implements OnChanges {
  @Input() userType!: string;

  @Input() presetFilter: Record<string, unknown> = {};
  @Input() showToolbar: boolean = true;
  @Input() showBalanceColumns: boolean = false;
  @Input() columnOrder: string[] = [];
  @Input() hiddenColumns: string[] = [];
  @Input() agentBalanceOf: string = '';
  @Input() showRoleBadge: boolean = false;
  @Input() showTotals: boolean = true;
  @Input() showOriginColumn: boolean = false;
  public readonly AGENT_BALANCE_MOMENTS = AGENT_BALANCE_MOMENTS;
  @Input() columnWidthsKey: string = '';
  @Input() transactionBackoffice!: string;
  @Input() transactionSorticenter!: string;

  @ViewChild('userTemplate', { static: true }) userTemplate!: TemplateRef<any>;
  @ViewChild('userWithRoleTemplate', { static: true }) userWithRoleTemplate!: TemplateRef<unknown>;
  @ViewChild('stateTransaction', { static: true })
  stateTransaction!: TemplateRef<any>;
  @ViewChild('type', { static: true })
  type!: TemplateRef<any>;
  @ViewChild('operationType', { static: true })
  operationType!: TemplateRef<any>;
  @ViewChild('originTemplate', { static: true }) originTemplate!: TemplateRef<unknown>;
  @ViewChild('createdAt', { static: true })
  public createdAtTemplate?: TemplateRef<HTMLElement>;
  @ViewChild('updatedAt', { static: true })
  public updatedAtTemplate?: TemplateRef<HTMLElement>;
  @ViewChild('amountTemplate', { static: true })
  amountTemplate!: TemplateRef<any>;
  @ViewChild('previousBalanceTemplate', { static: true })
  previousBalanceTemplate!: TemplateRef<any>;
  @ViewChild('currentBalanceTemplate', { static: true })
  currentBalanceTemplate!: TemplateRef<any>;
  @ViewChild('amountToneTemplate', { static: true })
  amountToneTemplate!: TemplateRef<unknown>;
  @ViewChild('previousBalanceToneTemplate', { static: true })
  previousBalanceToneTemplate!: TemplateRef<unknown>;
  @ViewChild('currentBalanceToneTemplate', { static: true })
  currentBalanceToneTemplate!: TemplateRef<unknown>;
  @ViewChild('agentPreviousBalanceTemplate', { static: true })
  agentPreviousBalanceTemplate!: TemplateRef<unknown>;
  @ViewChild('agentCurrentBalanceTemplate', { static: true })
  agentCurrentBalanceTemplate!: TemplateRef<unknown>;
  @ViewChild('previousCreditTemplate', { static: true })
  previousCreditTemplate!: TemplateRef<any>;
  @ViewChild('currentCreditTemplate', { static: true })
  currentCreditTemplate!: TemplateRef<any>;
  @ViewChild('previousRegisteredBalanceTemplate', { static: true })
  previousRegisteredBalanceTemplate!: TemplateRef<any>;
  @ViewChild('currentRegisteredBalanceTemplate', { static: true })
  currentRegisteredBalanceTemplate!: TemplateRef<any>;
  @ViewChild('previousRegisteredCreditTemplate', { static: true })
  previousRegisteredCreditTemplate!: TemplateRef<any>;
  @ViewChild('currentRegisteredCreditTemplate', { static: true })
  currentRegisteredCreditTemplate!: TemplateRef<any>;
  @ViewChild('playerTemplate', { static: true })
  public playerTemplate?: TemplateRef<HTMLElement>;
  @ViewChild('roleTemplate', { static: true })
  public roleTemplate?: TemplateRef<HTMLElement>;
  @ViewChild('userIdTemplate', { static: true })
  public userIdTemplate?: TemplateRef<HTMLElement>;
  @ViewChild('commentTemplate', { static: true })
  public commentTemplate?: TemplateRef<HTMLElement>;
  @ViewChild('belongsToTemplate', { static: true })
  public belongsToTemplate?: TemplateRef<HTMLElement>;

  public TRASACTION_STATUS_BADGE_OPTIONS = TRASACTION_STATUS_BADGE_OPTIONS;
  public TRASACTION_STATUS = TRASACTION_STATUS;

  public MONEY_TYPE_BADGE_OPTIONS = MONEY_TYPE_BADGE_OPTIONS;
  public MONEY_TYPE = MONEY_TYPE;

  public TRANSACTION_TYPE_BADGE_OPTIONS = TRANSACTION_TYPE_BADGE_OPTIONS;
  public TRANSACTION_TYPE = TRANSACTION_TYPE;

  public PAYMENT_TYPE_BADGE_OPTIONS = PAYMENT_TYPE_BADGE_OPTIONS;
  public PAYMENT_TYPE = PAYMENT_TYPE;

  public FORMAT_FOR_DATES_LONG = FORMAT_FOR_DATES_LONG;
  public BUTTON_ACTIONS = BUTTON_ACTIONS;
  private PAGINATION = DEFAULT_NGX_DATATABLE_PAGINATION;
  public USER_TYPE = USER_TYPE;
  public readonly PERMITTED_VIEWS = PERMITTED_VIEWS;
  public readonly TWO_DECIMALS = FORMAT_FOR_NUMBER_DIGITS;

  public config$ = new BehaviorSubject<Partial<NgxDatatableConfig>>({});
  public data$: Observable<TransactionAdmin[]> = of([]);
  private filter: Record<string, any> = {};
  private unsubscribe$: Subject<boolean> = new Subject<boolean>();
  public profile: User = {} as User;

  public exportLoading = false;

  public currentExportType: string = '';
  public currentDownloadType: string = '';
  public currentFilters: Record<string, any> = {};

  public currentLimit: number = DEFAULT_NGX_DATATABLE_PAGINATION.LIMIT;
  public currentPage: number = DEFAULT_NGX_DATATABLE_PAGINATION.PAGE;

  constructor(
    public lang: LanguageService,
    private _trasactionService: TransferService,
    private _filterService: FilterService<object>,
    private _bsModalService: BootstrapModalService<ModalWithAction<TransactionAdmin>>,
    private _profileService: GlobalService,
    private _reportDownloadService: ReportDownloadService
  ) {
    this.loadProfile();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const preset = changes['presetFilter'];
    const type = changes['userType'];
    if ((!preset || preset.firstChange) && (!type || type.firstChange)) return;

    if (type && !type.firstChange) {
      this.config$ = this.setConfigDatatable();
      this.currentLimit = this.config$.value.limit || this.PAGINATION.LIMIT;
    }
    this.updateCurrentFilters(this.filter);
    this.onChangePage(this.PAGINATION.PAGE);
  }

  ngOnInit(): void {
    this.suscribeFilter();
    this.config$ = this.setConfigDatatable();
    this.data$ = this.getAllReport(this.setFilter());

    this.updateCurrentFilters(this.filter);
  }

  loadProfile(): void {
    this._profileService.profile.subscribe((profile) => {
      this.profile = profile;
    });
  }
  private suscribeFilter(): void {
    this._filterService
      .getFilterData()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (filter: Record<string, any>) => {
          this.filter = filter;
          this.updateCurrentFilters(filter);
          this.currentPage = 1;
          this.currentLimit = this.config$.value.limit || this.PAGINATION.LIMIT;
          this.config$.next({
            ...this.config$.value,
            limit: this.currentLimit,
            page: 1,
          });
          this.data$ = this.getAllReport(this.setFilter());
        },
        error: () => this.reloadDatatable(),
      });
  }

  private updateCurrentFilters(filter: Record<string, any>): void {
    const enhancedFilters: Record<string, any> = { ...filter, ...this.presetFilter };

    if (this.userType) {
      enhancedFilters['userType'] = this.userType;
    }

    if (this.profile && this.profile._id) {
      enhancedFilters['userId'] = this.profile._id;
    }

    if (this.profile && this.profile.roleId && this.profile.roleId._id) {
      enhancedFilters['roleId'] = this.profile.roleId._id;
    }

    this.currentFilters = enhancedFilters;
  }

  private setConfigDatatable(): BehaviorSubject<Partial<NgxDatatableConfig>> {
    let columnsWithTemplates: Partial<NgxDatatableColumn>[] = [
      {
        name: 'reports.transactions.idTransaction',
        prop: 'transactionId',
      },
      {
        name: 'words.date',
        cellTemplate: this.createdAtTemplate ?? undefined,
      },
      {
        name: 'financial.transactions.filter.userId',
        prop: 'registeredBy.userId',
      },
      {
        name: 'reports.transactions.realisatedBy',
        prop: 'registeredBy.username',
      },
      {
        name: 'reports.transactions.performedByUserId',
        prop: 'registeredBy.roleId.name',
        width: 230,
      },
      ...(this.userType === USER_TYPE.PLAYER
        ? [
            {
              name: 'players.blocked.accordion.playerId',
              prop: 'userData.accountInfo.playerId',
              width: 200,
            },
          ]
        : this.userType === USER_TYPE.AGENT
          ? [
              {
                name: 'players.blocked.accordion.playerId',
                prop: 'userData.userId',
                width: 200,
              },
            ]
          : [
              {
                name: 'players.blocked.accordion.playerId',
                width: 200,
                cellTemplate: this.userIdTemplate,
              },
            ]),
      {
        name: 'reports.transactions.usernamePlayer',
        prop: 'userData',
        width: 200,
        cellTemplate: this.userTemplate,
      },
      {
        name: 'userManagement.users.role',
        prop: '',
        cellTemplate: this.roleTemplate,
      },
      {
        name: 'reports.transactions.belongsTo',
        cellTemplate: this.belongsToTemplate,
      },
      {
        name: 'reports.transactions.type',
        cellTemplate: this.type,
        width: 150,
      },
      {
        name: 'words.status',
        cellTemplate: this.stateTransaction,
        width: 150,
      },
      {
        name: 'reports.transactions.comment',
        cellTemplate: this.commentTemplate,
        width: 250,
      },
      { name: 'reports.transactions.IP', prop: 'ipAddress' },
      {
        name: 'reports.transactions.currencyId',
        prop: 'currencyId.code',
        width: 150,
      },
      {
        name: 'reports.transactions.amount',
        prop: 'amount',
        shouldSum: true,
        valueFormatter: formatNumberTwoDecimals,
      },
      {
        name: 'reports.transactions.operationType',
        cellTemplate: this.operationType,
        width: 150,
      },
      {
        name: 'reports.transactions.previousBalance',
        cellTemplate: this.previousBalanceTemplate,
      },
      {
        name: 'reports.transactions.currentBalance',
        cellTemplate: this.currentBalanceTemplate,
      },
      ...(this.userType !== USER_TYPE.PLAYER
        ? [
            {
              name: 'reports.transactions.previousCredit',
              cellTemplate: this.previousCreditTemplate,
            },
            {
              name: 'reports.transactions.currentCredit',
              cellTemplate: this.currentCreditTemplate,
            },
          ]
        : []),
    ];

    const excludedRoles = [USER_TYPE.AGENT, USER_TYPE.AFFILIATE];
    if (!excludedRoles.includes(this.profile.roleId.name)) {
      columnsWithTemplates.push(
        {
          name: 'reports.transactions.previousRegisteredBalance',
          cellTemplate: this.previousRegisteredBalanceTemplate,
        },
        {
          name: 'reports.transactions.currentRegisteredBalance',
          cellTemplate: this.currentRegisteredBalanceTemplate,
        },
        {
          name: 'reports.transactions.previousRegisteredCredit',
          cellTemplate: this.previousRegisteredCreditTemplate,
        },
        {
          name: 'reports.transactions.currentRegisteredCredit',
          cellTemplate: this.currentRegisteredCreditTemplate,
        }
      );
    }

    if (this.userType === USER_TYPE.AGENT) {
      columnsWithTemplates = [
        {
          name: 'reports.transactions.idTransaction',
          prop: 'transactionId',
        },
        {
          name: 'words.date',
          cellTemplate: this.createdAtTemplate ?? undefined,
        },
        {
          name: 'reports.transactions.currencyId',
          prop: 'currencyId.code',
          width: 150,
        },
        {
          name: 'reports.transactions.amount',
          prop: 'amount',
          shouldSum: true,
          valueFormatter: formatNumberTwoDecimals,
        },
        {
          name: 'reports.transactions.realisatedBy',
          prop: 'registeredBy.username',
        },
        {
          name: 'reports.transactions.usernamePlayer',
          prop: 'userData',
          width: 200,
          cellTemplate: this.userTemplate,
        },
        { name: 'reports.transactions.IP', prop: 'ipAddress' },
        {
          name: 'words.status',
          cellTemplate: this.stateTransaction,
          width: 150,
        },
        {
          name: 'reports.transactions.comment',
          cellTemplate: this.commentTemplate,
          width: 250,
        },
        {
          name: 'reports.transactions.type',
          cellTemplate: this.type,
          width: 150,
        },
        {
          name: 'reports.transactions.operationType',
          cellTemplate: this.operationType,
          width: 150,
        },
      ];
    } else if (this.userType === USER_TYPE.PLAYER) {
      columnsWithTemplates = [
        {
          name: 'reports.transactions.idTransaction',
          prop: 'transactionId',
        },
        {
          name: 'words.date',
          cellTemplate: this.createdAtTemplate ?? undefined,
        },
        {
          name: 'reports.transactions.currencyId',
          prop: 'currencyId.code',
          width: 150,
        },
        {
          name: 'reports.transactions.amount',
          prop: 'amount',
          shouldSum: true,
          valueFormatter: formatNumberTwoDecimals,
        },
        {
          name: 'reports.transactions.realisatedBy',
          prop: 'registeredBy.username',
        },
        {
          name: 'reports.transactions.usernamePlayer',
          prop: 'userData',
          width: 200,
          cellTemplate: this.userTemplate,
        },
        { name: 'reports.transactions.IP', prop: 'ipAddress' },
        {
          name: 'players.blocked.accordion.agentUserName',
          prop: 'playerId.accountInfo.agentId.username',
        },
        {
          name: 'words.status',
          cellTemplate: this.stateTransaction,
          width: 150,
        },
        {
          name: 'reports.transactions.comment',
          cellTemplate: this.commentTemplate,
          width: 250,
        },
        {
          name: 'reports.transactions.type',
          cellTemplate: this.type,
          width: 150,
        },
        {
          name: 'reports.transactions.operationType',
          cellTemplate: this.operationType,
          width: 150,
        },
      ];
    }

    if (this.showBalanceColumns) {
      columnsWithTemplates = this.withBalanceColumns(columnsWithTemplates);
    }

    if (this.showOriginColumn) {
      columnsWithTemplates = this.withOriginColumn(columnsWithTemplates);
    }

    if (this.columnOrder.length) {
      columnsWithTemplates = orderColumnsByName(columnsWithTemplates, this.columnOrder);
    }

    if (this.showRoleBadge) {
      columnsWithTemplates = this.withRoleBadge(columnsWithTemplates);
    }

    if (!this.showTotals) {
      columnsWithTemplates = this.withoutTotals(columnsWithTemplates);
    }

    if (this.hiddenColumns.length) {
      columnsWithTemplates = columnsWithTemplates.filter(
        (column) => !this.hiddenColumns.includes(column.name ?? '')
      );
    }

    columnsWithTemplates = this.applyColumnVisibilityRules(columnsWithTemplates);

    return new BehaviorSubject<Partial<NgxDatatableConfig>>({
      limit: 10,
      page: 1,
      columns: columnsWithTemplates,
    });
  }

  public agentBalance(row: TransactionAdmin, moment: AgentBalanceMoment): number | null {
    const usePrevious = moment === AGENT_BALANCE_MOMENTS.PREVIOUS || this.isRejected(row);
    switch (this.agentBalanceSource(row)) {
      case AGENT_BALANCE_SOURCES.OWN:
        return usePrevious ? row.previousBalance : row.currentBalance;
      case AGENT_BALANCE_SOURCES.REGISTERED:
        return (usePrevious ? row.previousRegisteredBalance : row.currentRegisteredBalance) ?? null;
      default:
        return row.agentBalanceSnapshot ?? null;
    }
  }

  public isAgentBalanceUnchanged(row: TransactionAdmin): boolean {
    return this.isRejected(row) || this.agentBalanceSource(row) === null;
  }

  public isRejected(row: TransactionAdmin): boolean {
    return row.stateTransaction === TRASACTION_STATUS.REJECTED;
  }
  public rejectedBalance(row: TransactionAdmin): number {
    return row.unchangedBalance ?? row.previousBalance;
  }

  public unchangedBalanceReason(row: TransactionAdmin): string {
    return this.isRejected(row)
      ? AGENT_BALANCE_UNCHANGED_REASONS.REJECTED
      : AGENT_BALANCE_UNCHANGED_REASONS.NOT_AGENT;
  }

  public originLabel(origin: unknown): string {
    const key = this.originKey(origin);
    const match = Object.values(TRANSACTION_ORIGINS).find((item) => item.en === key);
    if (!match) return key;
    return this.lang.code.value === AVAILABLE_LANGUAGES.EN ? match.en : match.es;
  }

  public originFlagClass(origin: unknown): string {
    return (
      TRANSACTION_ORIGIN_FLAG_CLASSES[this.originKey(origin)] ??
      TRANSACTION_ORIGIN_DEFAULT_FLAG_CLASS
    );
  }

  private agentBalanceSource(row: TransactionAdmin): AgentBalanceSource | null {
    if (getRefId(row.agentId) === this.agentBalanceOf) return AGENT_BALANCE_SOURCES.OWN;
    if (getRefId(row.registeredBy) === this.agentBalanceOf) return AGENT_BALANCE_SOURCES.REGISTERED;
    return null;
  }

  private originKey(origin: unknown): string {
    if (typeof origin === 'string') return origin;
    return (origin as { en?: string } | null)?.en ?? '';
  }

  private withOriginColumn(columns: Partial<NgxDatatableColumn>[]): Partial<NgxDatatableColumn>[] {
    const index = columns.findIndex(
      (column) => column.name === TRANSACTION_COLUMN_NAMES.OPERATION_TYPE
    );
    const result = [...columns];
    result.splice(index === -1 ? result.length : index + 1, 0, {
      name: TRANSACTION_COLUMN_NAMES.ORIGIN,
      cellTemplate: this.originTemplate,
      width: TRANSACTION_ORIGIN_COLUMN_WIDTH,
    });
    return result;
  }

  private withoutTotals(columns: Partial<NgxDatatableColumn>[]): Partial<NgxDatatableColumn>[] {
    return columns.map((column) =>
      'shouldSum' in column ? { ...column, shouldSum: false } : column
    );
  }

  private withRoleBadge(columns: Partial<NgxDatatableColumn>[]): Partial<NgxDatatableColumn>[] {
    return columns.map((column) =>
      column.name === TRANSACTION_COLUMN_NAMES.USERNAME_PLAYER
        ? { ...column, cellTemplate: this.userWithRoleTemplate }
        : column
    );
  }

  private withBalanceColumns(
    columns: Partial<NgxDatatableColumn>[]
  ): Partial<NgxDatatableColumn>[] {
    const balanceNames: string[] = [
      TRANSACTION_COLUMN_NAMES.PREVIOUS_BALANCE,
      TRANSACTION_COLUMN_NAMES.CURRENT_BALANCE,
    ];
    const rest = columns
      .filter((column) => !balanceNames.includes(column.name ?? ''))
      .map((column) =>
        column.name === TRANSACTION_COLUMN_NAMES.AMOUNT
          ? { ...column, cellTemplate: this.amountToneTemplate }
          : column
      );
    const amountIndex = rest.findIndex((column) => column.name === TRANSACTION_COLUMN_NAMES.AMOUNT);
    rest.splice(
      amountIndex + 1,
      0,
      {
        name: TRANSACTION_COLUMN_NAMES.PREVIOUS_BALANCE_SHORT,
        cellTemplate: this.agentBalanceOf
          ? this.agentPreviousBalanceTemplate
          : this.previousBalanceToneTemplate,
      },
      {
        name: TRANSACTION_COLUMN_NAMES.CURRENT_BALANCE_SHORT,
        cellTemplate: this.agentBalanceOf
          ? this.agentCurrentBalanceTemplate
          : this.currentBalanceToneTemplate,
      }
    );
    return rest;
  }

  private getAllReport(filter: Record<string, any>): Observable<TransactionAdmin[]> {
    this.config$.next({ ...this.config$.value, loadingIndicator: true });
    return this._trasactionService.findAllTransactionsReports(filter).pipe(
      tap((res) => {
        this.config$.next({
          ...this.config$.value,
          loadingIndicator: false,
          count: res.data.totalCount,
        });
      }),
      map((res) => res.data.result || [])
    );
  }

  private setFilter(): Record<string, any> {
    return {
      ...this.filter,
      ...this.presetFilter,
      limit: this.config$.value.limit,
      page: this.config$.value.page,
      userType: this.userType,
      userId: this.profile._id,
      roleId: this.profile.roleId._id,
    };
  }

  getDeepValue(obj: any, path: string): any {
    if (!path) return '';
    return (
      path.split('.').reduce((acc, part) => {
        if (acc && acc[part] !== undefined && acc[part] !== null) return acc[part];
        return '';
      }, obj) ?? ''
    );
  }

  getBelongsTo(row: any): string {
    return row?.playerId?.accountInfo?.agentId?.username || 'IS_AGENT';
  }

  public reloadDatatable(): void {
    this.config$.next({
      ...this.config$.value,
    });
    this.data$ = this.getAllReport(this.setFilter());
  }

  public onChangeLimit(limit: number): void {
    this.currentLimit = limit;
    this.config$.next({
      ...this.config$.value,
      limit,
      page: this.PAGINATION.PAGE,
    });
    this.data$ = this.getAllReport(this.setFilter());
  }

  public onChangePage(page: number): void {
    this.currentPage = page;
    this.config$.next({ ...this.config$.value, page });
    this.data$ = this.getAllReport(this.setFilter());
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  public onReportExportRequested(request: DownloadReportRequest): void {
    if (!this._reportDownloadService.validateExportRequest(request)) {
      return;
    }

    const downloadRequest = this._reportDownloadService.buildDownloadRequest(request);
    downloadRequest.filters = this.buildEnhancedFilters(downloadRequest.filters, request.filters);

    this._reportDownloadService
      .executeReportDownload(downloadRequest, this.unsubscribe$)
      .subscribe();
  }

  private buildEnhancedFilters(
    downloadFilters: Record<string, Object> | undefined,
    requestFilters: Record<string, Object> | undefined
  ): Record<string, any> {
    if (downloadFilters) {
      return this.enhanceExistingFilters(downloadFilters, requestFilters);
    } else {
      return this.createBaseFilters();
    }
  }

  private enhanceExistingFilters(
    downloadFilters: Record<string, Object>,
    requestFilters: Record<string, Object> | undefined
  ): Record<string, Object> {
    const enhancedFilters = { ...downloadFilters };
    const importantFilters = this.getImportantFilters();

    this.applyRequestFilters(enhancedFilters, requestFilters, importantFilters);
    this.applyCurrentFilters(enhancedFilters, importantFilters);
    this.applyProfileFilters(enhancedFilters);

    return enhancedFilters;
  }

  private getImportantFilters(): string[] {
    return [...INIT_FILTERS_REPORTS];
  }

  private applyRequestFilters(
    enhancedFilters: Record<string, Object>,
    requestFilters: Record<string, Object> | undefined,
    importantFilters: string[]
  ): void {
    if (!requestFilters) return;

    importantFilters.forEach((filter) => {
      if (this.isValidFilterValue(requestFilters[filter])) {
        enhancedFilters[filter] = requestFilters[filter];
      }
    });
  }

  private applyCurrentFilters(
    enhancedFilters: Record<string, Object>,
    importantFilters: string[]
  ): void {
    if (!this.currentFilters) return;

    importantFilters.forEach((filter) => {
      if (this.isValidFilterValue(this.currentFilters[filter]) && !enhancedFilters[filter]) {
        enhancedFilters[filter] = this.currentFilters[filter];
      }
    });
  }

  private applyProfileFilters(filters: Record<string, Object>): void {
    if (this.userType) {
      filters['userType'] = this.userType;
    }

    if (this.profile?._id) {
      filters['userId'] = this.profile._id;
    }

    if (this.profile?.roleId?._id) {
      filters['roleId'] = this.profile.roleId._id;
    }
  }

  private createBaseFilters(): Record<string, Object> {
    const newFilters: Record<string, Object> = {};
    this.applyProfileFilters(newFilters);
    return newFilters;
  }

  private isValidFilterValue(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
  }

  private formatDateCenter(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  private applyColumnVisibilityRules(columns: any[]): any[] {
    const userType = this.profile.userType.toString().trim().toLowerCase();

    if (!DEFAULT_ROLES_TO_HIDE_SET.has(userType)) {
      return columns;
    }

    const restrictedColumns = [
      {
        name: 'reports.transactions.IP',
        prop: 'ipAddress',
      },
      {
        name: 'reports.transactions.belongsTo',
        cellTemplate: this.belongsToTemplate,
      },
      {
        name: 'reports.transactions.previousCredit',
        cellTemplate: this.previousCreditTemplate,
      },
      {
        name: 'reports.transactions.currentCredit',
        cellTemplate: this.currentCreditTemplate,
      },
    ];

    return columns.filter((column) => !this.isRestrictedColumn(column, restrictedColumns));
  }

  private isRestrictedColumn(column: any, restrictedColumns: any[]): boolean {
    return restrictedColumns.some((restricted) => {
      const nameMatches = column.name === restricted.name;

      if (restricted.prop) {
        return nameMatches && column.prop === restricted.prop;
      }

      if (restricted.cellTemplate) {
        return nameMatches && column.cellTemplate === restricted.cellTemplate;
      }

      return nameMatches;
    });
  }
}
